module.exports = "/_next/static/images/about-the-product-kit-velieve@2x-min-f3abab876f44d8ee10856a4ea77f6ea2.png";